"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = removeTreeListener;

var _undelegatelistener = _interopRequireDefault(require("./_undelegatelistener"));

// removes tree listener from all object tree of fiven path
// TODO: Pass context to removeTreeListener
function removeTreeListener(object, deepPath, handler) {
  if (typeof deepPath === 'string') {
    deepPath = deepPath.split('.'); // eslint-disable-line no-param-reassign
  } // iterate over keys of the path and undelegate given handler (can be undefined)


  for (var i = 0; i < deepPath.length; i++) {
    // TODO: Array.prototype.slice is slow
    var listenedPath = deepPath.slice(0, i);
    (0, _undelegatelistener["default"])(object, listenedPath, "_change:tree:".concat(deepPath[i]), handler);
  }
}
//# sourceMappingURL=_removetreelistener.js.map